<template>
  <div>
      <div v-if="typeOfSearch === 'flight'">
        <b-checkbox
              :size="size"
              type="is-teal"
              native-value="Preferred Airlines Only"
              id="Preferred Airlines Only"
              v-model="selectedChainsValue"
              @input="handleInput"
            
          >
            <div>
              Preferred Airlines Only
              <!-- <b-tag rounded>
                {{ getCount(chain) }}
              </b-tag> -->
            </div>
          </b-checkbox>
          
        <div v-for="(chain, idx) in availableChains" :key="idx" :data-id="chain.code"           
              data-test="chain_filter_option">
          <b-checkbox
              :size="size"
              type="is-teal"
              :native-value="chain"
              :id="chain"
              v-model="selectedChainsValue"
              @input="handleInput"
              :data-id="chain.code"
              :disabled="!isAvailable(chain) && !isSelected(chain)"               
          >
            <div>
              {{ $helpers.airlineName(chain.code) }}
              <b-tag rounded class="chain-count">
                {{ getCount(chain) }}
              </b-tag>
            </div>
          </b-checkbox>
          <br />
        </div>
       
        
      </div>
    
      <div v-else>
        <div v-for="(chain, index) in availableChains" :key="index" :data-id="chain.code"           
              data-test="chain_filter_option">
          <b-checkbox
              :size="size"
              type="is-teal"
              :native-value="chain"
              :id="chain"
              v-model="selectedChainsValue"
              :disabled="!(filteredChains.includes(chain) || selectedChainsValue.includes(vendorsList))"
              @input="handleInput"
          >
          <div v-if="chain=='Preferred Vendors Only'">
            Preferred Vendors Only
            </div>
          <div v-else-if="vendorsList">
              {{ vendorsList[chain] !== '' ? vendorsList[chain] : 'Unknown Chain' }}
            </div>
            <div v-else>
              {{ chain }}
            </div>
          </b-checkbox>
          <br />
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: 'ChainSelection',
    data() {
        return {
          selectedChainsValue: this.selectedChains,
        }
    },
    props: {
      availableChains: Array,
      filteredChains: Array,
      selectedChains: Array,
      vendorsList: {},
      size: {
        type: String,
        default: 'is-small'
      },
      typeOfSearch: {
        type: String,
        required: false,
        default: '',
      },
    },
    methods: {
      handleInput () {
        this.$emit('input', this.selectedChainsValue);
      },

      handleHotelInput () {
        this.$emit('input', this.vendorsList[this.selectedChainsValue]);
      },
      isAvailable(chain){
        return this.filteredChains.findIndex(airline => airline.code == chain.code) > -1;
      },
      isSelected(chain){
        return this.selectedChains.findIndex(airline => airline.code == chain.code) > -1;
      },
      getCount(chain){
        let count = 0;
        let found = this.filteredChains.find(airline => airline.code == chain.code);
        if (found){
          count = found.resultsCount;
        }
        return count;

      }
    },
  }
</script>

<style lang="scss" scoped>
</style>
